import React, { useEffect, useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import MuiAlert from '@material-ui/lab/Alert';
import {
  createStyles,
  IconButton,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Link } from 'gatsby';
import { useIsMobile } from '../../util/style-utils';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import colors from '../../themes/main-colors';
import routes from '../../routes';
import { useTranslation } from '../../hooks/useTranslation';
import { Auth } from 'aws-amplify';


const useStyles = makeStyles(() =>
  createStyles({
    alert: {
      margin: '1em 1em 1em 1em',
      '& > .MuiAlert-message > p': {
        margin: 0,
      },
    },
    icon: { paddingTop: '13px' },
    iconMobile: { paddingTop: '8px' },
    action: { alignItems: 'start' },
    actionMobile: { alignItems: 'start', paddingTop: '6px' },
    message: { fontSize: '1.2rem', fontWeight: 700 },
    messageMobile: { fontSize: '1rem', fontWeight: 700 },
    filledInfo: {
      backgroundColor: colors.info,
      '& a': {
        color: '#FFF',
        fontWeight: 'bold',
      },
    },

    infoIcon: {
      '& path': {
        transform: 'scale(1.25) translateX(-2.5px) translateY(-2.5px)',
      },
      fill: colors.darkBlue,
      fontSize: 'inherit',
      background: colors.white,
      borderRadius: '50%',
      transform: 'scale(1.2)',
    },
  }),
);

const EnrollIntoTwoStepAuthNotice = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isMobile = useIsMobile();
  const classes = useStyles();
  const { t } = useTranslation();
  
  let actionClass;
  if (isMobile) {
    actionClass = classes.actionMobile;
  } else {
    actionClass = classes.action;
  }

  let messageClass;
  if (isMobile) {
    messageClass = classes.messageMobile;
  } else {
    messageClass = classes.message;
  }

  let iconClass;
  if (isMobile) {
    iconClass = classes.iconMobile;
  } else {
    iconClass = classes.icon;
  }

  useEffect(() => {
    const checkMFAStatus = async () => {
      const user = await Auth.currentAuthenticatedUser();
      const mfa = await Auth.getPreferredMFA(user);
      if (mfa === 'NOMFA') {
        setIsOpen(true);
      }
    };
    void checkMFAStatus();
  }, []);

  return (
    <Collapse in={isOpen} style={{ zIndex: 0 }}>
      <MuiAlert
        className={`${classes.filledInfo} ${classes.alert}`}
        classes={{
          icon: iconClass,
          action: actionClass,
          message: messageClass,
        }}
        severity={'info'}
        variant={'filled'}
        iconMapping={{
          info: <InfoIcon className={classes.infoIcon} />,
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size={isMobile ? 'small' : 'medium'}
            onClick={() => setIsOpen(false)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <Typography component="p">
          {t('ENABLE_TWO_STEP_AUTH_FOR_ACCOUNT_1')}
          <Link to={routes.TWO_STEP_AUTHENTICATION}>
            {t('TWO_STEP_AUTHENTICATION')}
          </Link>
          {t('ENABLE_TWO_STEP_AUTH_FOR_ACCOUNT_2')}
        </Typography>
      </MuiAlert>
    </Collapse>
  );
};

export default EnrollIntoTwoStepAuthNotice;
